import { Outlet, Route, Routes } from '@/util/react-router-dom';
import { RootRedirect } from './components/root-redirect';
import { CurrentUserProvider } from './contexts/current-user-context';
import { useMaterialIconsStylesheet } from './components/material-symbol-link';
import { I18nProvider } from './contexts/i18n-context';
import { ApiQueryClientProvider } from './contexts/api-query-client-context';
import { guestOnlyRoutes } from './routes/guest-only';
import { preAuthRoutes } from './routes/pre-auth';
import { publicRoutes } from './routes/public';
import { privateRoutes } from './routes/private';
import { ScrollToTop } from './components/scroll-to-top';
import { BrandingOutlet } from './outlets/branding-outlet';
import { ConvergeRedirect } from './pages/converge-redirect';

export function App() {
  // load the material icons stylesheet
  useMaterialIconsStylesheet();

  return (
    <I18nProvider>
      <Routes>
        <Route element={<AppOutlet />}>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/converge" element={<ConvergeRedirect />} />
          <Route path="/:name" element={<BrandingOutlet />}>
            {guestOnlyRoutes}
            {preAuthRoutes}
            {privateRoutes}
            {publicRoutes}
          </Route>
        </Route>
      </Routes>
    </I18nProvider>
  );
}

// The ApiQueryClientProvider needs useParams for navigating on errors,
// so that it needs to be inside Routes element
function AppOutlet() {
  return (
    <ApiQueryClientProvider>
      <ScrollToTop />
      <CurrentUserProvider>
        <Outlet />
      </CurrentUserProvider>
    </ApiQueryClientProvider>
  );
}
